import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCompanyAction } from "../actions/flowHubHeroCards.action";
import { ICreateFlownectCompany } from "../../../../../../../interfaces/ICompany.interface";
import { useSnackbar } from "../../../../../../../../../components/common/snackbar/useSnackbar";
import { useAppDispatch, useAppSelector } from "../../../../../../../../../redux/hooks/redux";
import { setActiveCompany, setCompanies } from "../../../../../../../../../redux/features/userStateSlice";
import { getSelfCompaniesAction } from "../../../../../../../../../middlewares/actions/companies-actions";
import { refreshGateway } from "../../../../../../../../../gateway";
export const useCreateCompany = () => {
    const queryClient = useQueryClient();
    const { showSnackbar } = useSnackbar();
    const dispatch = useAppDispatch();
    const activeCompanyId = useAppSelector(state => state.userState.activeCompanyId);
    const createCompanyMutation = useMutation({
        mutationFn: (values: ICreateFlownectCompany) => createCompanyAction(values),
        onSuccess: async () => {
            try {
                // 1. Force a token refresh to ensure the new company is authorized in the user's session/JWT
                const refreshToken = sessionStorage.getItem("refresh_token");
                if (refreshToken) {
                    try {
                        const refreshRes = await refreshGateway.post("/tokens/refresh", {}, {
                            headers: { Authorization: `Bearer ${refreshToken}` }
                        });
                        const { token, refresh_token: newRefreshToken } = refreshRes.data.data;
                        sessionStorage.setItem("token", token);
                        if (newRefreshToken?.token) {
                            sessionStorage.setItem("refresh_token", newRefreshToken.token);
                        } else if (typeof newRefreshToken === "string") {
                            sessionStorage.setItem("refresh_token", newRefreshToken);
                        }
                    } catch (refreshError) {
                        console.error("Token refresh failed after company creation", refreshError);
                    }
                }
                // 2. Manually fetch and update companies in Redux for immediate access
                // This call will now use the new token from localStorage (via axios interceptors)
                const res = await getSelfCompaniesAction();
                const companies = res?.data ?? res?.companies ?? res ?? [];
                dispatch(setCompanies(companies));
                if (!activeCompanyId && companies.length > 0) {
                    dispatch(setActiveCompany(companies[0].companyId));
                }
            } catch (error) {
                console.error("Error updating Redux state after company creation", error);
            }
            queryClient.invalidateQueries({ queryKey: ["companies-self"] });
            showSnackbar("Company created successfully", "success");
            console.log("Company created successfully");
        },
        onError: (error) => {
            showSnackbar("Failed to create company", "error");
            console.log("Failed to create company", error);
        },
    });
    return createCompanyMutation;
}